import { HStack, Text, colors } from "@biblioteksentralen/react";
import { useToggle } from "react-use";
import InternalLink from "../../components/InternalLink";
import { getPath } from "@libry-content/common";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { getWorksSortedOnRepresentativeManifestationTitle } from "../cordata/works";
import LabelAndValue from "./LabelAndValue";
import { LCWork } from "@libry-content/integrations";

type Props = {
  relatedWorks: LCWork[];
};

const ListRelatedWorks = ({ relatedWorks }: Props) => {
  const { t, lang } = useTranslation();
  const [showAllItems, toggleShowAllItems] = useToggle(false);
  const utilizeToggle = relatedWorks.length > 3 ? true : false;
  const associatedWorksWithFormattedTitle = getWorksSortedOnRepresentativeManifestationTitle(relatedWorks, lang);
  const nWorksShown = utilizeToggle ? (showAllItems ? relatedWorks.length : 3) : relatedWorks.length;

  return (
    <LabelAndValue fontSize="sm" label={t("Samling med")} marginTop="0">
      <HStack flexWrap="wrap" columnGap="0.25rem" gap="0" lineHeight="1.2">
        {associatedWorksWithFormattedTitle.slice(0, nWorksShown).map((associatedWork, index) => (
          <AssociatedWork key={associatedWork.id} relatedWork={associatedWork} index={index} length={nWorksShown} />
        ))}
        {utilizeToggle && (
          <Text key="toggleButton" as="button" fontWeight="600" zIndex="1000" onClick={toggleShowAllItems}>
            {showAllItems ? t("skjul") : `... ${t("vis mer")}`}
          </Text>
        )}
      </HStack>
    </LabelAndValue>
  );
};

type RelatedWorkProps = {
  relatedWork: LCWork;
  index: number;
  length: number;
};

const AssociatedWork = ({ relatedWork, index, length }: RelatedWorkProps) => {
  return (
    <InternalLink key={relatedWork.id} color={colors.black} href={getPath(relatedWork)}>
      {relatedWork.representativeWorkTriple?.getFormattedExpressionTitle() ?? relatedWork.formattedTitle}
      {index < length - 1 && ", "}
    </InternalLink>
  );
};

export default ListRelatedWorks;
